let sys = [
    {
        path: '/sys/sysconfig',
        name: 'sysconfig',
        component: () => import('@/views/sys/sysconfig.vue'),
        meta: {keepAlive: true, parentPath: 'sys'},
    },
    {
        path: '/sys/sysglobal',
        name: 'sysgloballist',
        component: () => import('@/views/sys/sysglobal/list.vue'),
        meta: {keepAlive: true, parentPath: 'sys'},
    },
    {
        path: '/sys/sysglobal/edit',
        name: 'sysglobaldit',
        component: () => import('@/views/sys/sysglobal/edit.vue'),
        meta: {keepAlive: true, parentPath: 'sys'},
    },
    {
        path: '/sys/pageextend',
        name: 'pageextend',
        component: () => import('@/views/sys/pageextend/list.vue'),
        meta: {keepAlive: true, parentPath: 'sys'},
    },
    {
        path: '/sys/pageextend/edit',
        name: 'pageextendedit',
        component: () => import('@/views/sys/pageextend/edit.vue'),
        meta: {keepAlive: true, parentPath: 'sys'},
    },
    {
        path: '/sys/pageextend/translation',
        name: 'pageextendtranslation',
        component: () => import('@/views/sys/pageextend/translation.vue'),
        meta: {keepAlive: true, parentPath: 'sys'},
    },
    {
        path: '/sys/help',
        name: 'helplist',
        component: () => import('@/views/sys/help/list.vue'),
        meta: {keepAlive: true, parentPath: 'sys'},
    }
    ,
    {
        path: '/sys/help/edit',
        name: 'helpedit',
        component: () => import('@/views/sys/help/edit.vue'),
        meta: {keepAlive: true, parentPath: 'sys'},
    }
    ,
    {
        path: '/sys/help/translation',
        name: 'helptranslation',
        component: () => import('@/views/sys/help/translation.vue'),
        meta: {keepAlive: true, parentPath: 'sys'},
    }
    ,
    {
        path: '/sys/sysCurrency',
        name: 'sysCurrency',
        component: () => import('@/views/sys/sysCurrency.vue'),
        meta: {keepAlive: true, parentPath: 'sys'}
    },
    {
        path: '/sys/express',
        name: 'express',
        component: () => import('@/views/sys/express/list.vue'),
        meta: {keepAlive: true, parentPath: 'sys'},
    },
    {
        path: '/sys/whatshelp',
        name: 'whatshelp',
        component: () => import('@/views/sys/whatshelp.vue'),
        meta: {keepAlive: true, parentPath: 'sys'},
    },
    {
        path: '/sys/payments',
        name: 'payments',
        component: () => import('@/views/sys/payments/index.vue'),
        meta: {keepAlive: true, parentPath: 'sys'},
    },
    {
        path: '/sys/navigation',
        name: 'navigation',
        component: () => import('@/views/sys/navigation/index.vue'),
        meta: {keepAlive: true, parentPath: 'sys'},
    },
    {
        path: '/sys/fareTemplate',
        name: 'fareTemplatelist',
        component: () => import('@/views/sys/fareTemplate/list.vue'),
        meta: {keepAlive: true, parentPath: 'sys'},
    },
    {
        path: '/sys/fareTemplate/edit',
        name: 'fareTemplateedit',
        component: () => import('@/views/sys/fareTemplate/edit.vue'),
        meta: {keepAlive: true, parentPath: 'sys'},
    },
    {
        path: '/sys/quartzJob',
        name: 'quartzJob',
        component: () => import('@/views/sys/quartzJob.vue'),
        meta: {keepAlive: true, parentPath: 'sys'},
    },
    {
        path: '/sys/meta/group',
        name: 'group',
        component: () => import('@/views/sys/meta/group/index.vue'),
        meta: {keepAlive: true, parentPath: 'sys'},
    },
    {
        path: '/sys/meta/group/edit',
        name: 'edit',
        component: () => import('@/views/sys/meta/group/edit.vue'),
        meta: {keepAlive: true, parentPath: 'sys'},
    }
    ,
    {
        path: '/sys/plugin',
        name: 'plugin',
        component: () => import('@/views/sys/plugin/index.vue'),
        meta: {keepAlive: true, parentPath: 'sys'},
    }
    ,
    {
        path: '/sys/plugin/llms',
        name: 'llms',
        component: () => import('@/views/sys/plugin/llms/index.vue'),
        meta: {keepAlive: true, parentPath: 'sys'},
    }
    ,
    {
        path: '/sys/plugin/autopost',
        name: 'autopost',
        component: () => import('@/views/sys/plugin/autopost/index.vue'),
        meta: {keepAlive: true, parentPath: 'sys'},
    }
    ,
    {
        path: '/sys/plugin/google',
        name: 'google',
        component: () => import('@/views/sys/plugin/google/index.vue'),
        meta: {keepAlive: true, parentPath: 'sys'},
    }
    ,
    {
        path: '/sys/plugin/facebook',
        name: 'facebook',
        component: () => import('@/views/sys/plugin/facebook/index.vue'),
        meta: {keepAlive: true, parentPath: 'sys'},
    }
    ,
    {
        path: '/sys/plugin/popups',
        name: 'popups',
        component: () => import('@/views/sys/plugin/popups/index.vue'),
        meta: {keepAlive: true, parentPath: 'sys'},
    }
    ,
    {
        path: '/sys/plugin/popups/edit',
        name: 'popupsedit',
        component: () => import('@/views/sys/plugin/popups/edit.vue'),
        meta: {keepAlive: true, parentPath: 'sys'},
    }
    
]
export default sys


// WEBPACK FOOTER //
// ./src/router/sys.js